import _regeneratorRuntime from "/home/vsts/work/1/s/node_modules/@babel/runtime/regenerator";
import "regenerator-runtime/runtime.js";
import _slicedToArray from "/home/vsts/work/1/s/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { isBrowser } from '@phx-husky/browser-helpers';
import { Platform, LdsContentFetchers } from '@phx-husky/fetch-lds';
import { useState, useEffect } from 'react';

function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}

var useUpdateOTLds = function useUpdateOTLds(lds) {
  var baseUrl = lds.baseUrl,
      businessId = lds.businessId,
      versionId = lds.versionId,
      locale = lds.locale,
      platform = lds.platform;

  var _useState = useState(undefined),
      _useState2 = _slicedToArray(_useState, 2),
      updatedLdsContent = _useState2[0],
      setUpdatedLdsContent = _useState2[1];

  var _useState3 = useState(isBrowser() && platform === Platform.OneTrust),
      _useState4 = _slicedToArray(_useState3, 2),
      isCheckingLdsVersion = _useState4[0],
      setIsCheckingLdsVersion = _useState4[1];

  useEffect(function () {
    if (!baseUrl) {
      setIsCheckingLdsVersion(false);
    } else if (isCheckingLdsVersion) {
      try {
        var fetchLds = function fetchLds() {
          return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
            return _regeneratorRuntime.wrap(function _callee$(_context) {
              while (1) {
                switch (_context.prev = _context.next) {
                  case 0:
                    LdsContentFetchers.ot({
                      uri: businessId,
                      config: {
                        otBaseUrl: baseUrl
                      },
                      locale: locale
                    }).then(function (data) {
                      if (data && data.versionId !== versionId) {
                        setUpdatedLdsContent(data.body);
                      }

                      setIsCheckingLdsVersion(false);
                    });

                  case 1:
                  case "end":
                    return _context.stop();
                }
              }
            }, _callee);
          }));
        };

        fetchLds();
      } catch (_a) {
        console.error('Failed to check for LDS updates.');
        setIsCheckingLdsVersion(false);
      }
    }
  }, []);
  return {
    updatedLdsContent: updatedLdsContent,
    isCheckingLdsVersion: isCheckingLdsVersion
  };
};

export { useUpdateOTLds };